import React from "react"
import { Button } from "@citydna/common"

export const SaveSchemaButton: React.FC<{ loading: boolean }> = ({
  loading,
}) => {
  return (
    <Button
      type="submit"
      color="secondary"
      variant="contained"
      loading={loading}
    >
      Save schema
    </Button>
  )
}
